<script lang="ts">
    import Link from "svelte-link/src/Link.svelte";
    import { Image } from "sveltestrap";
    import Tableheader from "../../../Data/ComponentData/DashboardData/Defaultdata/RecentOrders.json";
    import {Done, href} from "../../../utils/Constant/Constant"
    let imgPath : string= '/assets/images/dashboard';
</script>

{#each Tableheader.tablebody as Item}
  <tr>
    <td>
      <div class="media">
        <Image
          fluid
          class="rounded-circle"
          src={`${imgPath}/${Item.src}`}
          alt=""
          title=""
        />
        <div class="media-body">
          <Link href="/ecommerce/productpage"><span>{Item.name}</span></Link>
        </div>
      </div>
    </td>
    <td>
      <p>{Item.date}</p>
    </td>
    <td>
      <p>{Item.quantity}</p>
    </td>
    <td>
      <Image fluid src={`${imgPath}/${Item.valuesrc}`} alt="" title="" />
    </td>
    <td>
      <p>{Item.rate}</p>
    </td>
    <td>
      <p>{Done}</p>
    </td>
  </tr>
{/each}
